import React,{ useState, useEffect } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import baseURL from '../Url/Url.jsx'

const Register = () => {
    const [userName, setUserName] = useState('')
    const [password, setPassword] = useState('')
    const [confPassword, setConfPassword] = useState('')
    const [perusahaan, setPerusahaan] = useState('')
    const [ktp, setKtp] = useState('')
    const [namaLengkap, setNamaLengkap] = useState('')
    const [msg, setMsg] = useState('')
    const [displayLoader, setDisplayLoader] = useState("")
    const navigate = useNavigate()
    
    useEffect(()=>{
        setDisplayLoader("none")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // register
    const register = async(e)=>{
        e.preventDefault()
        try {
            setDisplayLoader("")
            await axios.post(`${baseURL}/usersBE`,{
                userName: userName,
                password: password,
                confPassword: confPassword,
                perusahaan: perusahaan,
                ktp: ktp,
                namaLengkap: namaLengkap
            })
            navigate('/', { replace: true })
            window.location.reload()
        } catch (error) {
            if(error.response){
                setDisplayLoader("none")
                setMsg(error.response.data.msg)
            }
        }
    }
    
    // Halaman
    return (
        <div>
            <div className="loader-page-bg" style={{display:displayLoader}}>
                <div className="loader-page"></div>
            </div>

            <div className='container mb-4' style={{marginTop:"80px"}}>
                {/* MODAL */}
                <div className="modal fade" id="staticBackdropDaftar" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="btn btn-logout mx-auto py-1 px-3" data-bs-dismiss="modal" aria-label="Kembali">Kembali</button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={register}>
                                    <h6 style={{textAlign:"center",marginTop:"-8px",marginBottom:"0px",color:"red"}}>{msg}</h6>
                                    <div className='row justify-content-center'>
                                        <input type='text' id='userNameModal' className='form-disable' placeholder='Masukan username' value={userName}readOnly required/>
                                        <input type='text' id='perusahaanModal' className='form-disable' placeholder='Masukan Nama' value={perusahaan} readOnly required/>
                                        <input type='password' id='passwordModal' className='form-disable' placeholder='Buat password baru' value={password} readOnly required/>
                                        <input type='password' id='confPasswordModal' className='form-disable' placeholder='Ulangi password' value={confPassword} readOnly required/>
                                        <p className="text-center mt-3">Isi KTP dan Nama Lengkap anda dibawah ini, ini akan digunakan jika lupa password</p>
                                        <div className="row">
                                            <div className='col-12 col-sm-6 mb-2'>
                                                <input type='number' id='ktp' className='form-control form' placeholder='Masukan No. KTP Anda' value={ktp} onChange={(e) => setKtp(e.target.value)} required/>
                                            </div>
                                            <div className='col-12 col-sm-6'>
                                                <input type='text' id='namaLengkap' className='form-control form' placeholder='Masukan Nama Lengkap Anda' value={namaLengkap} onChange={(e) => setNamaLengkap(e.target.value)} required/>
                                            </div>
                                        </div>
                                    </div>
                                    <input type='submit' className='btn btn-webew-login my-4' value='Daftar'/>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* MODAL */}
                <div className='row justify-content-center'>
                    <div className='col-11 col-sm-10 col-md-8 col-lg-7 col-xl-6'>
                        <div className='box-login'>
                            <h4 className='text-center mb-4' style={{fontWeight:'700'}}>Daftar Akun Mantap</h4>
                            <h6 style={{textAlign:"center",marginTop:"-8px",marginBottom:"0px",color:"red"}}>{msg}</h6>
                            <div className='row justify-content-center'>
                                <div className='col-12 col-sm-6'>
                                    <input type='text' id='userName' className='form-control form mb-3 mt-4' placeholder='Buat Username' value={userName} onChange={(e) => setUserName(e.target.value)} required autoFocus/>
                                </div>
                                <div className='col-12 col-sm-6'>
                                    <input type='text' id='perusahaan' className='form-control form mb-3 mt-4' placeholder='Nama Perusahaan' value={perusahaan} onChange={(e) => setPerusahaan(e.target.value)} required/>
                                </div>
                                <div className='col-12 col-sm-6'>
                                    <input type='password' id='password' className='form-control form mb-3 mt-4' placeholder='Buat password' value={password} onChange={(e) => setPassword(e.target.value)} required/>
                                    { password.length === 0 ? <p></p> : password.length >= 8 ? <p></p> : <p style={{marginLeft:"10px",marginTop:"-15px",marginBottom:"-16px",color:"red",fontSize:"10pt"}}>Password minimal 8 karakter</p>}
                                    { password.length >= 8 ? <p style={{marginLeft:"10px",marginTop:"-15px",marginBottom:"0px",color:"blue",fontSize:"10pt"}}>Password sudah 8 karakter</p> : <p></p>}
                                </div>
                                <div className='col-12 col-sm-6'>
                                    <input type='password' id='confPassword' className='form-control form mb-3 mt-4' placeholder='Ulangi password' value={confPassword} onChange={(e) => setConfPassword(e.target.value)} required/>
                                </div>
                            </div>
                            {password.length <= 7 ?<button type='button' className='btn btn-webew-login mb-4 mt-4'>Lanjut</button>:<button type='button' className='btn btn-webew-login mb-4 mt-4' data-bs-toggle="modal" data-bs-target="#staticBackdropDaftar">Lanjut</button>}
                            <a href='/' style={{color:'rgb(0, 86, 247)', margin:'auto', display:'block', textAlign:'center', fontSize:'11pt'}}>Sudah punya akun ? login disini</a>
                            <a href="/menu-lupa-password" style={{color:"rgb(0, 86, 247)", margin:"auto", display:"block", textAlign:"center", fontSize:"11pt"}}>Lupa Password ? klik disini</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Register